export const get1LevelUrl = () => {
  const splitted = window.location.hostname.split('.')
  let url = window.location.origin
  if (splitted[splitted.length - 2]) {
    url = `${window.location.protocol}//${splitted[splitted.length - 2]}.${splitted[splitted.length - 1]}`
  }
  return url
}
